import * as yup from 'yup'

const schema = yup.object().shape({
  content: yup.string().required().max(5000),
  attachments: yup.mixed().fileUpload({ sizeLimit: 15 }),
})

export default schema
